import React ,{ useContext, useEffect, useState} from "react"
import { Auth} from "../AuthContext/Firebase"
import {
    getFirestore,
    setDoc,
    doc
} from "firebase/firestore"
import {
    createUserWithEmailAndPassword ,
    signInWithEmailAndPassword ,
    signOut
} from "firebase/auth";


const AuthContext = React.createContext()
export function UseAuth() {
    return useContext(AuthContext)
}

export function AuthProvader({children}){
    const [crentuser , setcrentuser] = useState(null)
    const datbase = getFirestore()
    //const colref= collection(datbase, "Users")

    function  sinup(email, password){
        return  createUserWithEmailAndPassword(Auth, email, password)
    }

    function  Login(email, password){
        return  signInWithEmailAndPassword(Auth, email, password)
    }


    function  Logout(){
        return  signOut(Auth)
    }
    
    useEffect(() =>{
        const unsubs =  Auth.onAuthStateChanged(user => {
            setcrentuser(user)
        })
        return unsubs
    },[])




    // adding data user functions
    function  adddate_user(Name, image , Nooc_akoon , user_id){
        return setDoc(doc(datbase, "Users", user_id), {
            Name,
            image,
            Nooc_akoon,
        })
    }
    // update data user functions


    // delete data user functions


    const value = {
        crentuser,
        sinup,
        Login,
        Logout,
        adddate_user,
    }

    return(
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}